/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.ColorSquare = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var PropertyHelper_1 = __importDefault(require("./helpers/PropertyHelper"));

var name = 'ColorSquare';
exports.name = name;

var ColorSquare = function ColorSquare(_ref) {
  var Frame = _ref.Frame,
      Image = _ref.Image,
      Tooltip = _ref.Tooltip,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(_class, _react_1$default$Comp);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.renderInner = _this.renderInner.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "renderInner",
      value: function renderInner() {
        var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var classes = arguments.length > 1 ? arguments[1] : undefined;
        var style = arguments.length > 2 ? arguments[2] : undefined;
        var _this$props = this.props,
            env = _this$props.env,
            model = _this$props.model;
        return image ? react_1.default.createElement(Image, {
          className: ['ColorSquare__square--inner', classes.imageSquare],
          style: styles === null || styles === void 0 ? void 0 : styles.imageSquare,
          src: PropertyHelper_1.default.getThumbnailUrl(env, model, image)
        }) : react_1.default.createElement(Frame, {
          className: ['ColorSquare__square--gradient', classes.gradient],
          style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.gradient), style === null || style === void 0 ? void 0 : style.gradient)
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            after = _this$props2.after,
            before = _this$props2.before,
            classes = _this$props2.classes,
            hex = _this$props2.hex,
            image = _this$props2.image,
            isSelected = _this$props2.isSelected,
            _onClick = _this$props2.onClick,
            shape = _this$props2.shape,
            style = _this$props2.style,
            tooltip = _this$props2.tooltip;
        return react_1.default.createElement(Frame, {
          className: ['ColorSquare__container', classes === null || classes === void 0 ? void 0 : classes.container, _defineProperty({}, classes.selected, isSelected), _defineProperty({}, classes.clickable, !!_onClick), _defineProperty({}, classes.square, shape === 'square')],
          style: brightsmith_core_1.Util.jssMerge(styles === null || styles === void 0 ? void 0 : styles.container, style === null || style === void 0 ? void 0 : style.square, isSelected ? styles === null || styles === void 0 ? void 0 : styles.selected : {}),
          onClick: function onClick() {
            if (_onClick) _onClick();
          }
        }, react_1.default.createElement(Tooltip, {
          className: ['ColorSquare__tooltip', classes === null || classes === void 0 ? void 0 : classes.tooltip],
          containerClass: classes === null || classes === void 0 ? void 0 : classes.tooltipContainer,
          text: tooltip,
          style: styles === null || styles === void 0 ? void 0 : styles.tooltip,
          containerStyle: styles === null || styles === void 0 ? void 0 : styles.tooltipContainer
        }, react_1.default.createElement(Frame, {
          className: ['ColorSquare__square--inner', classes === null || classes === void 0 ? void 0 : classes.colorSquare],
          style: Object.assign({
            backgroundColor: hex
          }, styles === null || styles === void 0 ? void 0 : styles.colorSquare)
        }, before, this.renderInner(image, classes, style), after)));
      }
    }]);

    return _class;
  }(react_1.default.Component);
};

exports.ColorSquare = ColorSquare;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  return {
    container: Object.assign({
      borderColor: '#000',
      borderStyle: 'solid',
      borderWidth: 1,
      boxSizing: 'border-box',
      display: 'flex',
      height: 45,
      margin: 3,
      width: 45
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _a === void 0 ? void 0 : _a.container),
    circle: Object.assign({
      borderRadius: '50%'
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _b === void 0 ? void 0 : _b.circle),
    clickable: {
      cursor: 'pointer'
    },
    colorSquare: Object.assign({
      height: '100%',
      width: '100%'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _c === void 0 ? void 0 : _c.colorSquare),
    gradient: Object.assign({
      background: 'linear-gradient(35deg, rgba(0,0,0,0.35), transparent)',
      height: '100%',
      width: '100%'
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _d === void 0 ? void 0 : _d.gradient),
    imageSquare: Object.assign({
      backgroundSize: 'cover',
      height: '100%',
      width: '100%'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _e === void 0 ? void 0 : _e.innerSquare),
    selected: Object.assign({
      borderColor: '#fff',
      borderStyle: 'solid',
      borderWidth: 3,
      boxShadow: '1px 1px 4px 0 #aaa',
      height: 49,
      margin: 1,
      width: 49
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _f === void 0 ? void 0 : _f.selected),
    square: Object.assign({
      borderRadius: 0
    }, (_g = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _g === void 0 ? void 0 : _g.square),
    tooltip: Object.assign({
      backgroundColor: '#000',
      color: '#fff',
      fontSize: 12,
      padding: 5,
      textAlign: 'center',
      top: '33%'
    }, (_h = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _h === void 0 ? void 0 : _h.tooltip),
    tooltipContainer: Object.assign({
      height: '100%',
      width: '100%'
    }, (_j = theme === null || theme === void 0 ? void 0 : theme.ColorSquare) === null || _j === void 0 ? void 0 : _j.tooltipContainer)
  };
};

exports.style = style;